import * as React from 'react';
import styled from 'styled-components';
import * as Color from 'core/colors';

const QUIZ_TYPE_LABELS: Record<string, string> = {
  V4MultipleChoiceSingleSelect: 'Multiple Choice',
  SentenceMultipleChoiceLimited: 'Sentence Multiple Choice',
  ReverseMultipleChoiceLimited: 'Reverse Multiple Choice',
  V4FillInTheBlank: 'Fill in the Blank',
  V4ReverseFillInTheBlank: 'Type the foreign word',
  SentenceFillInTheBlank: 'Sentence Fill in the Blank',
  DictationFillInTheBlank: 'Dictation',
  V4RegionReverseMultipleChoice: 'Region Multiple Choice',
  V4RegionReverseClickInTheDark: 'Region Click',
  V4SequenceJumble: 'Sequence Jumble',
};

interface Props {
  variantIndex: number;
  variantCount: number;
  currentQuizType: string;
  onVariantChange: (index: number) => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${Color.veryLightBlue};
  border-bottom: 1px solid ${Color.lightGray};
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: ${Color.primaryBlue};
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    background: ${Color.secondaryBlue};
  }

  &:disabled {
    color: ${Color.lightGray};
    cursor: default;
    &:hover {
      background: none;
    }
  }
`;

const Label = styled.span`
  font-size: 14px;
  color: ${Color.primaryBlack};
  margin: 0 8px;
  user-select: none;
`;

const DifficultyLevelCycler: React.FC<Props> = ({ variantIndex, variantCount, currentQuizType, onVariantChange }) => {
  const label = QUIZ_TYPE_LABELS[currentQuizType] || currentQuizType;

  return (
    <Container>
      <ArrowButton
        onClick={() => onVariantChange(variantIndex - 1)}
        disabled={variantIndex === 0}
        aria-label="Previous variant"
      >
        &#8592;
      </ArrowButton>
      <Label>
        &ldquo;{label}&rdquo; ({variantIndex + 1}/{variantCount})
      </Label>
      <ArrowButton
        onClick={() => onVariantChange(variantIndex + 1)}
        disabled={variantIndex === variantCount - 1}
        aria-label="Next variant"
      >
        &#8594;
      </ArrowButton>
    </Container>
  );
};

export default DifficultyLevelCycler;
